import { Notice, Text } from 'braid-design-system';

type DialogErrorNoticeProps = {
  message?: string | null;
};

export const DialogErrorNotice = ({ message }: DialogErrorNoticeProps) => {
  if (!message) {
    return null;
  }

  return (
    <Notice tone="critical">
      <Text>{message}</Text>
    </Notice>
  );
};
